module.exports = {
  MenuManagement: 'Menu Management',
  CustomerMenu: 'Customer Menu',
  CustomerAutomation: 'Customer Automation',
  Search: 'Search',
  PleaseEnterChinese: 'Please Enter Chinese、 English、Code',
  AddMenu: 'Add Menu',
  UpdateMenu: 'Update Menu',
  AddCustomerMenu: 'Add Customer Menu',
  Refresh: 'Refresh',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  Coding: 'Coding',
  Icon: 'Icon',
  Node: 'Node',
  ParentNode: 'Parent Node',
  Order: 'Order',
  ModuleFile: 'Module File',
  H5Url: 'H5 Url',
  Type: 'Type',
  Module: 'Module',
  Component: 'Component',
  Save: 'Save',
  Cancel: 'Cancel',
  OK: 'OK',
  Add: 'Add',
  Update: 'Update',
  ChineseCanNotBeEmpty: 'Chinese Can Not Be Empty',
  EnglishCanNotBeEmpty: 'English Can Not Be Empty',
  TheEncodingCanNotBeEmpty: 'The Encoding Can Not Be Empty',
  SavedSuccess: 'Saved Successfully',
  PleaseSelectTheMenu: 'Please Select The Menu',
  PleaseSelectTheCustomer: 'Please Select The Customer',
  NoCustomersWantToAdd: 'No Customers Want To Add',
  Prompt: 'Prompt',
  Removed: 'Removed',
  Numbering: 'Number',
  delete: 'Delete',
  CompanyChineseName: 'Chinese Name',
  SuccessfullyDeleted: 'Successfully Deleted',
  DeleteData: 'Please Select A Client That Needs To Be Deleted',
  UpdateData: 'Please Choose To Modify Customer Information',
  InitData: 'Please Select The Customer Who Needs To View The Underlying Data',
  SearchTitle: 'Please Enter Your Company Name Or Company Code',
  BasicData: 'Basic Data',
  ExpiredCustomerNotification: 'Expired Customer Notification',
  CompanyName: 'Company Name',
  CompanyCode: 'Company Code',
  CompanyPhone: 'Company Phone',
  CompanyEMail: 'Company E-Mail',
  CompanyFax: 'Company Fax',
  CreateDate: 'Create Date',
  GroupCompany: 'Group Company',
  InitializeCustomer: 'Registered Companies',
  copy: 'Select The Desired Replication Environment',
  InitializeData: 'Initialize The Underlying Data',
  InitializeMenu: 'Initialize The Menu',
  CompanyNamePrompt: 'Company Name Is Required',
  mailbox: 'The Administrator Mailbox Is Required',
  UpdateSuccess: 'Modify The Information Successfully',
  Initialized: 'Initialized Successfully',
  CompanyAddress: 'Company Address',
  AdminChineseName: 'Administrator Chinese Name',
  AdminEnglishName: 'Administrator English Name',
  email: 'Administrator Email',
  phone: 'Administrator Phone',
  Current: 'TenantId',
  StandardLibrary: 'Standard Environment',
  Initialize: 'Initialize',
  Next: 'Next',
  Back: 'Back',
  Finish: 'Finish',
  Harbour: 'Harbour',
  Airport: 'Airport',
  ChargesItems: 'Charges Items',
  AirRoute: 'Air Route',
  NetWork: 'NetWork',
  Currency: ' 通貨',
  EQType: 'EQ Type',
  Packing: 'PACKING',
  HouseBlType: 'House Bl Type',
  CargoType: 'Cargo Type',
  IncoTerm: 'Inco Term',
  ShippingTerm: 'Shipping Term',
  TradeTerm: 'Trade Term',
  CustomerType: 'Customer Type',
  PortGroup: 'Port Group',
  OtherChargeItem: 'Other Charge Item',
  ShippingCompaniesAirlines: 'Shipping Companies, Airlines',
  Template: 'Template',
  AirService: 'Air Service',
  BlMode: 'Bl Mode',
  CustomJobType: '通関業務区分',
  TransmitFileType: 'Transmit File Type',
  copyTenantId: 'Select The Desired Replication Platform',
  imgToolTip: 'Fill Out Company Information And System Administrator\nAdministrator\'s Mailbox To Logon Credentials',
  imgToolTip2: 'Need Copy Of Template',
  imgToolTip3: 'Platform Based Data',
  imgToolTip4: 'Platform Menu',
  Sequence: 'Sequence',
  documentCategory: 'File Types Management',
  charegeUnit: 'Charge Unit',
  BusinessStatus: '業務ステータス',
  PermissionConfig: 'Permission Configuration',
  Report: 'Report',
  ConfigurationManagement: 'Configuration Management',
  SingleOnlineSet: 'Single Online Set',
  IsH5Open: 'Is H5 Open',
  CopySetting: 'Copy Setting',
  AllOpen: 'All Open',
  AllClose: 'All Close',
  Start: 'Start',
  StandardLibrary2: 'Standard Library',
  OnlineCustomerService: 'カスタマーサービス担当',
  SubmitATicket: '作業指示書の提出',
  CheckTheTicket: '作業指示書を見る',
  Menu1: 'Menu',
  HelpCenter: 'ヘルプサービス',
  HelpVideo: 'Help Video',
  SystemOperationGuidance: 'SystemOperation Guidance',
  InitializeBoot: 'Initialize Boot',
  SpareQQ: '備考QQ',
  SettingsAndTools: '設置とツール',
  ReportStatistics: '集計統計',
  Weibo: 'WEIBO',
  LogInformation: '日記',
  BillingSystem: '経費記録',
  UnbindWeChat: 'ウェチャット関連',
  SystemInformation: 'システム情報',
  SignOut: 'ログアウト',
  WallTechFamily: 'WallTech Family',
  Notice: 'Notice',
  ClearLog: 'Clear Log',
  UploadLog: 'Upload Log',
  AuthorizationToken: 'Authorization Token:',
  LogLevel: 'Log Level',
  Source: 'Source:',
  AccountInformation: 'Account Information',
  ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere: 'Show your account number and the companies and departments to which you belong here.',
  InStationMessageReminder: 'In-station message reminder',
  WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime: 'When you have a pending task, there will be a to-do number on the bell to remind you to deal with it in time.',
  ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation: 'Click here to enter WallTech Family to view your order, training videos and other information.',
  WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime: 'When you encounter problems with your operating system, you can contact our online customer service at any time.',
  MultilingualSwitching: 'Multilingual switching',
  SwitchDifferentLanguages: 'Switch different languages.',
  HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation: 'Here is a helpful center, system-related configuration tools, report statistics, billing system and other more information.',
  OperationArea: 'Operation area',
  HereIsTheOperationInterfaceForYourDailyWork: 'Here is the operation interface for your daily work.',
  MenuBar: 'Menu bar',
  TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount: 'The system module menu bar displayed here matches the permissions of your login account.',
  More: 'More',
  Skip: 'Skip',
  WeChatUnbindingFailed: 'WeChat unbinding failed',
  WhetherToConfirmWeChatUnbinding: 'Whether to confirm WeChat unbinding?',
  Unbind: 'Unbind',
  WeChatUnbindingSuccessfully: 'WeChat unbinding successfully',
  DearYouHaventBoundYourWeChatAccountYet: 'Dear, you haven\'t bound your WeChat account yet.',
  AdministratorInitializationOperationGuidance: 'Administrator initialization operation guidance',
  ImproveEnterpriseInformation: 'Improve enterprise information',
  PleaseImproveYourCompanyEnterpriseInformation: 'Please improve your company\'s enterprise information',
  CreateAUser: 'Create a user.',
  CreateOurUsersAndSetPermissions: 'Create our users and set permissions',
  CustomerDataImport: 'Customer data import',
  InitializeAndImportTheCompanyOriginalCustomerInformation: 'Initialize and import the company\'s original customer information',
  ViewTheSteps: 'View the steps',
  YouAreNotAuthorizedToUseStatisticalAnalysisFunction: 'You are not authorized to use statistical analysis function.'
}
